'use client'

import { EditBankDataButton } from 'refunds/components/EditBankDataButton/EditBankDataButton'

import style from './BankInfoCard.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface BankInfoCardProps {
	readonly title?: string
	readonly showEditButton: boolean
	readonly handleEdit?: () => void
	readonly bodyContent: React.ReactNode
}

export function BankInfoCard({
	title,
	showEditButton,
	handleEdit,
	bodyContent,
}: BankInfoCardProps) {
	return (
		<div className={style.container}>
			<div className={style.header}>
				<h3 className={`${text.titleL} ${style.title}`}>{title}</h3>
				{showEditButton && (
					<EditBankDataButton
						label='myReturns.request.summary.refundInfo.bankDetails.edit.link'
						handleEdit={handleEdit}
					/>
				)}
			</div>
			{bodyContent}
		</div>
	)
}
